// Build the ancestor breadcrumb crumbs for a catch-all `slug` param. Each crumb
// gets a `full_slug` that must resolve as a real page — `AppBreadcrumbs` prefixes
// a single `/`, so any extra character here ships a link that 404s and also
// poisons the BreadcrumbList JSON-LD `@id`.
export function buildBreadcrumbParents(slug) {
    if (!Array.isArray(slug) || slug.length <= 1) {
        return []
    }

    return slug.filter(item => item !== '').slice(0, -1).map((item, index) => ({
        name: (item.charAt(0).toUpperCase() + item.slice(1)).replace('-', ' '),
        full_slug: slug.slice(0, index + 1).join('/'),
    }))
}
